import React, { useState, useEffect, useRef } from "react";
import { Link, useHistory } from "react-router-dom";
import { Tab, Nav, Dropdown } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useSnackbar } from "react-simple-snackbar";
import { Modal } from "react-bootstrap";
import { MyVerticallyCenteredModal } from "../SpeakerProfileModal";
import {
  StudentUpcomingSession,
  StudentPastSession,
  GetSessionDocs,
  sessionCancelled,
  sessionAttendance
} from "../../redux/actions/SessionAction";
import {
  currentTimeLocal,
  currentTimeUtc,
  formatAMPM,
  formatTimeslotAMPM,
  LocalToutc,
  utcToLocal,
  utcToLocalDateConverter,
} from "../../helpers/TimeDate";
import { ZoomMeetingRecording } from "../../redux/actions/ZoomMeeting";
import emptyTeacher from "../../assets/emptyTeacher.jpg";
import Loder from "../../components/loder";
import FeedbackModal from "../../components/MessageModal/FeedbackModal";
import { initGA, initPixel } from "../../helpers/CampaignEvents";
import VideoApprovalModal from "../../components/VideoApprovalModal";
import InfiniteScroll from "react-infinite-scroll-component";

const SessionPage = (props) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [openSnackbar, closeSnackbar] = useSnackbar();
  const user = JSON.parse(localStorage.getItem("USER"));
  const time_zone = JSON.parse(localStorage.getItem("TIMEZONE"));

  const [page, setPage] = useState(1);
  const [tab, setTab] = useState("upcomming");
  const [cancellationId, setCancellationId] = useState("");
  const [cancellation, setCancellation] = useState(false);

  const handleCancellationClose = () => setCancellation(false);
  const handleCancellation = () => setCancellation(true);

  //loders
  const [infiniteLoding, setInfiniteLoding] = useState(false);
  const [docLoding, setDocLoding] = useState(false);
  const [recordingLoding, setRecordingLoder] = useState(false);
  const [cancel, setCancel] = useState(false);
  const [join, setJoin] = useState(false);
  const [learnerfeedbackShow, setlearnerfeedbackShow] = useState(false);
  const [sessionId, setSessionId] = useState("");
  const [sessionNo, setSessionNo] = useState();
  // const [clickAction, setClickAction] = useState();
  // const previousValue = useRef();

  // useEffect(() => {
  //   previousValue.current = clickAction;
  //   console.log(previousValue.current === clickAction)
  // }, [clickAction]);
  //redux store
  const upcomming = useSelector((state) => state.UserReducer.upcomingSession);
  const past = useSelector((state) => state.UserReducer.pastSession);
  const imgUrl = "https://s3.ap-south-1.amazonaws.com/cdn.clapingo.com/clapingoWeb";

  useEffect(() => {
    initPixel();
    initGA();
  }, []);

  const handleScroll = () => {
    // const { scrollTop, clientHeight, scrollHeight } = e.currentTarget;
    // if (scrollHeight === clientHeight) {
    //   return;
    // }
    // if (scrollHeight - scrollTop === clientHeight) {
    console.log("hogaya");
    setInfiniteLoding(true)
    if (tab === "upcomming") {
      dispatch(
        StudentUpcomingSession({
          studentID: user._id,
          page: page + 1,
          limit: 10,
          timezone: time_zone.timezone,
        })
      );
      setPage(page + 1);
      setInfiniteLoding(false)
    } else if (tab === "pastsession") {
      dispatch(
        StudentPastSession({
          studentID: user._id,
          page: page + 1,
          limit: 10,
          timezone: time_zone.timezone,
        })
      );
      setPage(page + 1);
      setInfiniteLoding(false)
    }
    // }
  };

  // learnerFeedback
  const feedbackFunction = (id, no) => {
    setlearnerfeedbackShow(true);
    setSessionId(id);
    setSessionNo(no);
  };

  const OpenSessionDoc = (doc, sessionId, type) => {
    if (type === "LinkAvailable") {
      const docUrl = doc.split("=");
      localStorage.setItem("SESSION_DOC", JSON.stringify(docUrl[1]));
      history.push("/document");
    } else {
      setDocLoding(sessionId);
      const data = {
        sessionCount: doc,
      };
      const onSuccess = (data) => {
        setDocLoding(false);
        if (data.statusCode === 404) {
          openSnackbar(data.message);
        } else {
          // console.log(data);
          const url = data.note.noteLink;
          const docUrl = url.split("=");
          localStorage.setItem("SESSION_DOC", JSON.stringify(docUrl[1]));
          history.push("/document");
        }
      };
      const onErr = (msg) => {
        setDocLoding(false);
        openSnackbar(msg);
      };
      dispatch(GetSessionDocs(data, onSuccess, onErr));
    }
  };


  //open recording
  const recording = (id) => {
    setRecordingLoder(id);
    const data = {
      meetingId: id,
    };
    const onSuccess = (data) => {
      setRecordingLoder(false);
      window.location.replace(data.recording_files[0].play_url);
    };
    const onError = () => {
      setRecordingLoder(false);
      openSnackbar("Recording not found for this session !!");
    };
    dispatch(ZoomMeetingRecording(data, onSuccess, onError));
    // window.location.replace("http://www.w3schools.com");
  };

  //cancel session
  const cancelSession = (sessionId) => {
    //console.log(sessionId)
    setCancel(sessionId);
    const onSuccess = (msg) => {
      openSnackbar(msg);
      setCancel(false);
      window.location.reload();
    };
    const onErr = (msg) => {
      openSnackbar(msg);
      setCancel(false);
    };
    dispatch(
      sessionCancelled(
        { sessionId: sessionId, timezone: time_zone.timezone },
        onSuccess,
        onErr
      )
    );
  };

  //joining meeting
  const joinMeeting = (data) => {
    setJoin(data._id);
    if (data.isTimeUtc) {
      var joiningDate = utcToLocal(data.sessionDate, data.startTime);
      var leavingDate = utcToLocal(data.sessionDate, data.endTime);
      var currentTime = new Date();
      if (joiningDate > currentTime) {
        setJoin(false);
        openSnackbar("Your session not started yet");
      } else if (leavingDate < currentTime) {
        setJoin(false);
        openSnackbar("Your session time is over");
      } else {

        localStorage.setItem("FEEDBACK_TIME", JSON.stringify({
          sessionNo: data.sessionCount,
          time: leavingDate,
          id: data._id
        }));

        const onSuccess = () => {
          setJoin(false);
          const url = `https://zoom.clapingo.com/?meetingNumber=${data.meetingNo}&passWord=${data.meetingPassword}&userName=${data.learner.name}&leaveurl=${window.location.href}&endTime=${leavingDate}`;
          window.location.replace(url);
        }

        const onError = (msg) => {
          setJoin(false);
          openSnackbar(msg);
        }

        dispatch(
          sessionAttendance({
            sessionID: data._id,
            joiningTime: currentTimeUtc()
          },
            onSuccess,
            onError
          )
        );


      }
    }
  };

  console.log(past)
  return (
    <div className="session_page_wrapper">
      {/* <hr className="line"></hr> */}

      <div className="session_card content mt-5 mt-md-2">

        <div className="card mx-auto">
          <InfiniteScroll dataLength={past ? past.length : 0}
            next={() => handleScroll()}
            hasMore={true}
            style={{ overflow: "hidden", width: "100%" }}
          // loader={<h4>Loading...</h4>}
          >
            <div className="card-body m-3">
              <Tab.Container
                className="mt-3"
                id="left-tabs-example"
                defaultActiveKey="first"
              >
                <Nav variant="pills" className="flex-row">
                  <Nav.Item>
                    <Nav.Link
                      eventKey="first"
                      onClick={() => setTab("upcomming")}
                    >
                      {window.innerWidth < 992 ? "Upcoming" : "Upcoming Session"}

                    </Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link
                      eventKey="second"
                      onClick={() => setTab("pastsession")}
                    >
                      {window.innerWidth < 992 ? "Past" : "Past Session"}

                    </Nav.Link>
                  </Nav.Item>
                </Nav>

                <Tab.Content className="container mt-4">
                  <Tab.Pane eventKey="first">
                    <div className="row" style={{ top: "130px" }}>
                      {upcomming ? (
                        upcomming[0] ? (
                          upcomming.map((data, i) => (
                            <div className={`col-md-4 mt-3 ${data.isCancel ? "wrap" : ""}`} key={i}>
                              <div className={`upcoming_past_session_card ${data.isCancel ? "cancelled" : ""}`}>
                                <div class="speaker_img_container">
                                  <div className="row">
                                    <div className="col-md-6">
                                      <a href style={{ cursor: "pointer" }}>
                                        <img
                                          className="teacher_image mx-auto m-1"
                                          // onClick={() =>
                                          //   history.push(
                                          //     `/speaker-profiles/${data.teacher._id}`
                                          //   )
                                          // }
                                          src={
                                            data?.teacher?.image
                                              ? data.teacher.image
                                              : emptyTeacher
                                          }
                                          alt="icon"
                                        />
                                      </a>
                                    </div>
                                    
                                    <div className="col-md-6">
                                      <div className="name_tag">
                                        {data.type === "Regular"
                                          ? "Session" + " " + data.sessionCount
                                          : "Demo Session"}
                                      </div>

                                      <div className="tutor-name mt-2">
                                        <small>Tutor :</small>
                                        {/* <Link
                                          to={`/speaker-profiles/${data?.teacher?._id}`}
                                          className="name"
                                        > */}
                                        
                                        {/* </Link> */}
                                      </div> 
                                      
                                      <MyVerticallyCenteredModal
                                        // show={modalShow}
                                        id={data.teacher._id} attributeOnClick = {data?.teacher?.name}
                                      // onHide={() => setModalShow(false)}

                                      /> <br/>
                                      <MyVerticallyCenteredModal
                                        // show={modalShow}
                                        id={data.teacher._id} attributeOnClick = {"More slots"}
                                      // onHide={() => setModalShow(false)}

                                      />
                                      {data.type === "Regular" ? (
                                        <p
                                          className="notes"
                                          onClick={() =>
                                            OpenSessionDoc(
                                              data.sessionCount,
                                              data._id
                                            )
                                          }
                                        >
                                          {docLoding === data._id
                                            ? "Fetching..."
                                            : "Session notes"}{" "}
                                          <i className="fas fa-download"></i>
                                        </p>
                                      ) : (
                                        <p
                                          className="notes"
                                          style={{ cursor: "pointer" }}
                                          onClick={() =>
                                            OpenSessionDoc(
                                              "url=https://clapngobucket.s3.amazonaws.com/documents/learner/Demo+Session+Document_compressed.pdf",
                                              data._id,
                                              "LinkAvailable"
                                            )
                                          }
                                        >
                                          {docLoding === data._id
                                            ? "Fetching..."
                                            : "Demo notes"}{" "}
                                          <i className="fas fa-download"></i>
                                        </p>
                                      )}
                                    </div>
                                  </div>
                                </div>
                                {data.cancelBy? <div style={{ fontSize: "10px" }}><i class="fas fa-sync"></i> Re-assigned from <span style={{ color:"orange", fontWeight:"bold"}}>{data.cancelBy.name}</span><br/><span style={{color:"blueviolet", fontSize:"10px"}}>Due to an emergency, tutor won't be able to join this session. You have been re-assigned to a new tutor.</span></div>  :""}
                                <div className="action_container mt-2">
                                  <div className="d-md-flex justify-content-between">
                                 
                                    <div className="time">
                                      <small>Time</small>
                                      <p>
                                        {data.isTimeUtc
                                          ? formatTimeslotAMPM(`${data.startTime}-${data.endTime}`)
                                          : data.startTime + " - " + data.endTime}

                                      </p>
                                    </div>
                                    <div className="date">
                                      <small>Date</small>
                                      <p>{utcToLocalDateConverter(data.sessionDate, data.endTime)}</p>
                                    </div>
                                  </div>
                                </div>


                                {window.innerWidth < 992 ? <p style={{ color: "red", fontSize: "10px" }}>Video calls are not supported in mobile web. For best experience use a Laptop or Clapingo App<br /> <a href="https://play.google.com/store/apps/details?id=com.app.clapingo">
                                  <img src={`https://images.weserv.nl/?url=${imgUrl}/gplay.png&w=135&h=40&output=webp`} height="50%" width="50%" alt="mobile.png" />
                                </a>


                                  <a href="https://apps.apple.com/in/app/clapingo/id1595487516">
                                    <img src={`https://images.weserv.nl/?url=${imgUrl}/apple.png&w=135&h=40&output=webp`} height="50%" width="50%" alt="mobile.png" />
                                  </a></p> : ""}


                                <div className="session_buttons d-flex  justify-content-between mt-2 flex-row-reverse">
                                  {window.innerWidth < 992 ?
                                    <button
                                      id="joinupcoming"
                                      className="join"
                                      onClick={() => joinMeeting(data)}
                                      disabled={true}
                                    >
                                      {join === data._id ? "Joining.." : "Join"}
                                    </button> :
                                    <button
                                      id="joinupcoming"
                                      className="join"
                                      onClick={() => joinMeeting(data)}
                                      disabled={join}
                                    >
                                      {join === data._id ? "Joining.." : "Join"}
                                    </button>}

                                  {data.type === "Regular" ? (

                                    <button
                                      id="cancelupcoming"
                                      className="cancel"
                                      onClick={() => { handleCancellation(); setCancellationId(data._id) }}
                                    >
                                      cancel
                                    </button>
                                  ) : (
                                    ""
                                  )}
                                </div>


                              </div>
                              <div
                                className={` ${data.isCancel ? "override" : ""}`}
                              >
                                {data.isCancel ? <h3>Cancelled!</h3> : ""}
                              </div>
                            </div>

                          ))
                        ) : (
                          <p className="text-center mt-4 col-12">
                            Upcoming session not available
                          </p>
                        )
                      ) : (
                        <div
                          className="m-5 text-center col-12"
                          style={{ width: "100%" }}
                        >
                          <Loder />
                        </div>
                      )}
                    </div>
                  </Tab.Pane>
                  <Tab.Pane eventKey="second">
                    <div className="row" style={{ top: "130px" }}>
                      {past ? (
                        past[0] ? (
                          past.map((data, i) => (
                            <div className={`col-md-4 mt-3 ${data.isCancel ? "wrap" : ""}`} key={i}>
                              <div className={`upcoming_past_session_card ${data.isCancel ? "cancelled" : ""}`}>
                                <div class="speaker_img_container">
                                  <div className="row">
                                    <div className="col-md-6">
                                      <a href style={{ cursor: "pointer" }}>
                                        <img
                                          className="teacher_image mx-auto m-1"
                                          // onClick={() =>
                                          //   history.push(
                                          //     `/speaker-profiles/${data.teacher._id}`
                                          //   )
                                          // }
                                          src={
                                            data?.teacher?.image
                                              ? data.teacher.image
                                              : emptyTeacher
                                          }
                                          alt="icon"
                                        />
                                      </a>
                                    </div>

                                    <div className="col-md-6">
                                      <div className="name_tag">
                                        {data.type === "Regular"
                                          ? "Session" + " " + data.sessionCount
                                          : "Demo Session"}
                                      </div>


                                      <div className="tutor-name mt-2">
                                        <small>Tutor :</small>
                                        {/* <Link
                                          to={`/speaker-profiles/${data?.teacher?._id}`}
                                          className="name"
                                        > */}
                                        {data?.teacher?.name}
                                        {/* </Link> */}
                                      </div>

                                      {data.type === "Regular" ? (
                                        <p
                                          className="notes"
                                          onClick={() =>
                                            OpenSessionDoc(
                                              data.sessionCount,
                                              data._id
                                            )
                                          }
                                        >
                                          {docLoding === data._id
                                            ? "Fetching..."
                                            : "Session notes"}{" "}
                                          <i className="fas fa-download"></i>
                                        </p>
                                      ) : (
                                        <p
                                          className="notes"
                                          style={{ cursor: "pointer" }}
                                          onClick={() =>
                                            OpenSessionDoc(
                                              "url=https://clapngobucket.s3.amazonaws.com/documents/learner/Demo+Session+Document_compressed.pdf",
                                              data._id,
                                              "LinkAvailable"
                                            )
                                          }
                                        >
                                          {docLoding === data._id
                                            ? "Fetching..."
                                            : "Demo notes"}{" "}
                                          <i className="fas fa-download"></i>
                                        </p>
                                      )}
                                    </div>
                                  </div>
                                </div>

                                <div className="action_container mt-2">
                                  <div className="d-md-flex justify-content-between">
                                    <div className="time">
                                      <small>Time</small>
                                      <p>
                                        {data.isTimeUtc
                                          ? formatTimeslotAMPM(`${data.startTime}-${data.endTime}`)
                                          : data.startTime + " - " + data.endTime}
                                      </p>
                                    </div>
                                    <div className="date">
                                      <small>Date</small>
                                      <p>{utcToLocalDateConverter(data.sessionDate, data.endTime)}</p>
                                    </div>
                                  </div>
                                </div>

                                {
                                  data.teacher.isYoutubeConsentSigned ?
                                    <div className="row session_buttons pl-3 pr-3 mt-2">
                                      {data.ytApprovalData?.approved_video_url ?
                                        <button
                                          onClick={(e) => {
                                            e.preventDefault();
                                            window.location.href = data.ytApprovalData.approved_video_url;
                                          }}
                                          className="col-12 approved">
                                          <i class="fab fa-youtube"></i> YouTube Approved
                                        </button>
                                        :
                                        <>
                                          {data.ytApprovalData?.status ?
                                            <button style={{ fontSize: "10px", lineHeight: "15px" }}>{`Approval status: ${data.ytApprovalData.status} `}</button>
                                            : <VideoApprovalModal meetingRecording={data.meetingRecording} sessioId={data._id} meetingNo={data.meetingNo} />
                                          }
                                        </>
                                      }
                                    </div>
                                    : ""
                                }


                                <div className="session_buttons d-flex  justify-content-between mt-2 flex-row-reverse">
                                  <button
                                    id="joinupcoming"
                                    className="join"
                                    onClick={() =>
                                      feedbackFunction(
                                        data._id,
                                        data.sessionCount
                                      )
                                    }
                                  >
                                    Feedback
                                  </button>

                                  <button
                                    id="cancelupcoming"
                                    className="cancel"
                                    onClick={() =>
                                      data.meetingRecording &&
                                        data.meetingRecording !== "na"
                                        ? history.push({
                                          pathname:
                                            "student/session/recording",
                                          state: data.meetingRecording,
                                        })
                                        : recording(data.meetingNo)
                                    }
                                  >
                                    {recordingLoding === data.meetingNo
                                      ? "Fetching.."
                                      : "Recording"}
                                  </button>

                                </div>


                              </div>
                              <div
                                className={` ${data.isCancel ? "override" : ""}`}
                              >
                                {data.isCancel ? <h3>Cancelled!</h3> : ""}
                              </div>

                            </div>

                          ))

                        ) : (
                          <p className="text-center mt-4 col-12">
                            Past session not available{" "}
                          </p>
                        )
                      ) : (
                        <div
                          className="m-5 text-center col-12"
                          style={{ width: "100%" }}
                        >
                          <Loder />
                        </div>
                      )}
                    </div>
                  </Tab.Pane>
                </Tab.Content>
              </Tab.Container>
            </div>
          </InfiniteScroll>
        </div>

      </div>
      {/* MODALS */}
      {/* <LearnerFeedback
        show={learnerfeedbackShow}
        onHide={() => setlearnerfeedbackShow(false)}
        data={sessionId}
      /> */}
      <FeedbackModal
        show={learnerfeedbackShow}
        setShow={setlearnerfeedbackShow}
        id={sessionId}
        number={sessionNo}
      />
      {/* Session Cancellation Confirmation Modal */}
      <Modal
        show={cancellation}
        onHide={handleCancellationClose}
        {...props}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="feedback"
      >
        <Modal.Body>
          <div className="text-center">
            <h3>Confirm Session Cancellation</h3>
            <p>Are you sure you want to cancel your session?</p>
          </div>
          <div className="d-flex justify-content-center">
            <button
              style={{ margin: "0px", width: "150px", height: "35px" }}
              onClick={() => cancelSession(cancellationId)}
            >
              {cancel === cancellationId ? "canceling.." : "Yes"}
            </button>
            <button
              style={{
                margin: "0px",
                width: "150px",
                height: "35px",
                marginLeft: "20px",
              }}
              onClick={() => handleCancellationClose()}
            >
              No
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default SessionPage;
